import {
  getAllOrders,
  getOrder,
  updateOrder,
  newOrder,
  deleteOrder, updateOrderItem, deleteOrderItem, newOrderItem,
} from '../order-service';

export default {
  /**
   * Get All orders
   * @param commit
   * @param page
   * @param limit
   * @returns {Promise<void>}
   */
  async fetchAllOrders({ commit }, { page, limit, options }) {
    const response = await getAllOrders(page, limit, options);
    commit('setProperty', { property: 'orders', payload: response.data });
    const pagination = {
      page: response.pagination.page,
      perPage: response.pagination.perPage,
      lastPage: response.pagination.lastPage,
      total: Number(response.pagination.total),
    };
    commit('setProperty', { property: 'pagination', payload: pagination });
  },

  /**
   *
   * @param commit
   * @param orderId
   * @returns {Promise<void>}
   */
  async getOrder({ commit }, { orderId }) {
    const response = await getOrder(orderId);
    commit('setProperty', { property: 'order', payload: response });
    commit('setProperty', { property: 'orderedItemsTotal', payload: response.orderedItems.reduce((a, el) => a + el.item_price, 0)})
  },

  /**
   *
   * @param commit
   * @param orderId
   * @returns {Promise<void>}
   */
  async deleteOrder({ commit }, { orderId }) {
    await deleteOrder(orderId);
    commit('delProperty', { property: orderId });
  },

  /**
   *
   * @param commit
   * @param orderId
   * @param order
   * @returns {Promise<void>}
   */
  async updateOrder({ commit }, { orderId, order }) {
    const response = await updateOrder(orderId, order);
    commit('setProperty', { property: 'order', payload: response });
  },

  /**
   *
   * @param context
   * @param order
   * @returns {Promise<void>}
   */
  async newOrder({ commit }, { order }) {
    const response = await newOrder(order);
    commit('setNewOrder', { payload: response });
    commit('setProperty', { property: 'order', payload: response });
  },

  /**
   *
   * @param commit
   * @param orderedItem
   * @returns {Promise<void>}
   */
  async newOrderItem({ commit }, { orderedItem }) {
    const response = await newOrderItem(orderedItem);
    commit('setProperty', { property: 'order', payload: response });
  },

  /**
   *
   * @param commit
   * @param orderedItemId
   * @param orderedItem
   * @returns {Promise<void>}
   */
  async updateOrderItem({ commit }, { orderedItemId, orderedItem }) {
    const response = await updateOrderItem(orderedItemId, orderedItem);
    commit('setProperty', { property: 'order', payload: response });
  },

  /**
   *
   * @param commit
   * @param orderId
   * @param order
   * @returns {Promise<void>}
   */
  async deleteOrderItem({ commit }, { orderId }) {
    const response = await deleteOrderItem(orderId);
    commit('setProperty', { property: 'order', payload: response });
  },
};
